import axios from '../../../axios';
import ComposeEmailDTO from '../types/ComposeEmailDTO';
import { ConfiguredEmailContextType } from '../types/ConfiguredEmailContext';
import Email from '../types/Email';
import ICalendarDTO from '../types/ICalendarDTO';

export const testEmail = (config: Email) =>
  axios.post('emailingapp/api/recruiter-smtp-accounts/test-mail', config);
export const saveEmail = (config: Email) =>
  axios.post('emailingapp/api/recruiter-smtp-accounts', config);

export const getConfiguredEmails = () => axios.get('emailingapp/api/recruiter-smtp-accounts');

export const connectGoogleAccount = () => axios.get('emailingapp/api/google-auth/email');

export const connectMicrosoftAccount = () => axios.get('emailingapp/api/outlook-auth/email');

export const deleteConfiguredAccount = (email: Email) =>
  axios.delete(`emailingapp/api/recruiter-smtp-accounts/${email}`);

export const updateSignature = (config: ConfiguredEmailContextType) =>
  axios.put('emailingapp/api/recruiter-smtp-accounts/email-signature', config);

export const updateDefaultEmailStatus = (accountId: string, isDefault: boolean) =>
  axios.post('emailingapp/api/recruiter-smtp-accounts/default', { accountId, isDefault });

export const configureCalendarAccount = () => axios.get('emailingapp/api/google-auth/calendar');

export const getConfiguredCalendarAccounts = () =>
  axios.get('emailingapp/api/google-auth/calendar-accounts');

export const deleteConfiguredCalendarAccounts = (payload: ICalendarDTO) =>
  axios.put('emailingapp/api/google-auth', payload);

// Microsoft
export const configureOutlookCalendarAccount = () =>
  axios.get('emailingapp/api/outlook-auth/calendar');
export const getConfiguredOutlookCalendarAccounts = () =>
  axios.get('emailingapp/api/outlook-auth/calendar-accounts');
export const deleteConfiguredOutlookCalendarAccounts = (payload: ICalendarDTO) =>
  axios.put('emailingapp/api/outlook-auth', payload);

export const composeEmailService = (payload: ComposeEmailDTO) =>
  axios.post(`emailingapp/api/compose-email/send`, payload);

export const getOutlookCalendarAccountsForRecruiter = (recruiterId: string) =>
  axios.get('emailingapp/api/outlook-auth/calendar-accounts', { params: { recruiterId } });

export const getGoogleCalendarAccountsForRecruiter = (recruiterId: string) =>
  axios.get('emailingapp/api/google-auth/calendar-accounts', { params: { recruiterId } });
